export default __webpack_public_path__ + "static/media/img-slider-handigo-3.09e97c98.png";